import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';
import { Role } from '../shared/models/role.model';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {

  constructor(private http: HttpClient,
    private appConfigService: AppConfigService) { }

  getAllRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.appConfigService.getConfig().apiBaseUrl + 'Role');
  }

  getPermissionsByRoleId(id): Observable<any[]> {
    return this.http.get<any[]>(this.appConfigService.getConfig().apiBaseUrl + 'Role/' + id + '/Permission');
  }

  getPermissionsByUserName(id): Observable<any> {
    return this.http.get<any>(this.appConfigService.getConfig().apiBaseUrl + 'User/' + id + '/Permission');
  }

  getPermissionByDeviceIdUserId(userId,deviceId): Observable<any>{
     return this.http.get<any>(this.appConfigService.getConfig().apiBaseUrl + 'User/' + userId + '/' + deviceId + '/Permission');
  }


}
